"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineReelsController = void 0;
/**
 * Created by Jonas Wålekvist on 2020-01-17.
 */
const TimelineReelConfig_1 = require("./TimelineReelConfig");
const GameConfig_1 = require("../../core/gameconfig/GameConfig");
const gsap_1 = require("gsap");
const EventHandler_1 = require("../../core/event/EventHandler");
const ReelEvent_1 = require("../../core/reel/event/ReelEvent");
const GameEvent_1 = require("../../core/event/GameEvent");
const GameSetting_1 = require("../../core/setting/GameSetting");
const Reels_1 = require("../../core/reel/reelarea/Reels");
const SpinReelEvent_1 = require("../../game/reel/spinreel/SpinReelEvent");
const ReelAnimationState_1 = require("../../core/reel/reel/ReelAnimationState");
//import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
class TimelineReelsController extends Reels_1.Reels {
    static get instance() {
        return Reels_1.Reels._instance;
    }
    constructor() {
        super();
        this._reelConfigs = [];
        for (let i = 0; i < GameConfig_1.GameConfig.instance.REELS_NUM; i++) {
            this._reelConfigs.push(new TimelineReelConfig_1.TimelineReelConfig(i));
        }
    }
    addEventListeners() {
        // EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        // EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.onSpinStart(event.params[0]));
        EventHandler_1.EventHandler.addEventListener(this, ReelEvent_1.ReelEvent.REEL_SPIN_STARTED, (event) => this.onReelSpinStarted(event.params[0]));
        //EventHandler.addLastEventListener(this, ReelEvent.ALL_REELS_STOP_SPIN, (event:GameEvent) => this.onStopSpin(event.params[0]));
        EventHandler_1.EventHandler.addLastEventListener(this, ReelEvent_1.ReelEvent.REEL_STOP_SPIN_ANIMATION_COMPLETE, (event) => this.onReelSpinAnimationStopped(event.params[0]));
        EventHandler_1.EventHandler.addEventListener(this, ReelEvent_1.ReelEvent.REEL_STOP_SPIN_COMPLETE, (event) => this.onReelSpinStopped(event.params[0]));
        if (GameConfig_1.GameConfig.instance.SPIN_MODE === 0 /* SpinMode.SPIN */) {
            EventHandler_1.EventHandler.addLastEventListener(this, SpinReelEvent_1.SpinReelEvent.REEL_STOP_SPIN_BOUNCE_STARTED, (event) => this.onReelBounceStarted(event.params[0]));
        }
    }
    startSpin(reelId) {
        const reelConfig = this._reelConfigs[reelId];
        const durationPadding = 0.1;
        const tl = new gsap_1.TimelineLite({
            onStart: () => {
                Reels_1.Reels._reels[reelId].startSpin({
                    active: true,
                    fastSpin: GameSetting_1.GameSetting.isFastSpin
                }, 0);
            }
        });
        tl.add(new gsap_1.TweenLite(this, reelConfig.startDuration + durationPadding, {}));
        /*        tl.add(()=>{
                    Logger.logDev(`start done: ${reelId}`);
                })*/
        return tl;
    }
    stopSpin(reelId, data, quickStop = false, stopSpinData) {
        const tl = new gsap_1.TimelineLite();
        const reelConfig = this._reelConfigs[reelId];
        const reel = Reels_1.Reels._reels[reelId];
        if (reel.currentState === ReelAnimationState_1.ReelAnimationState.STOP_SPIN) {
            tl.add(new gsap_1.TweenLite(this, reel.currentSpinStepLeftTime, {}));
            tl.add(() => {
                EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(ReelEvent_1.ReelEvent.REEL_STOP_PRESENTATIONS_COMPLETE, reelId));
            });
            return tl;
        }
        const stopData = stopSpinData != undefined ? stopSpinData : {
            quickStop: quickStop,
            fastSpin: GameSetting_1.GameSetting.isFastSpin,
            active: true,
            spinStopOffset: 0, //send 0 here, can be modified as usual in the reelsController.
        };
        //const duration:number = (GameSetting.isFastSpin || quickStop) ? reelConfig.quickStopDuration : reelConfig.stopDuration;
        const duration = reel.calculateStopTime(reel.getSpinStopOffset());
        tl.eventCallback("onStart", () => {
            stopData.spinStopOffset = reel.getSpinStopOffset();
            const stopDuration = reel.stopSpin(stopData, 0);
            const padding = 0.04;
            tl.add(new gsap_1.TweenLite(this, stopDuration + padding, {}), 0);
            tl.add(() => {
                //Logger.logDev(`stop done: ${reelId}`);
                EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(ReelEvent_1.ReelEvent.REEL_STOP_PRESENTATIONS_COMPLETE, reelId)); //The reel is listening and waiting for this event for it to complete. Because we don't have this type of presentations anymore, this is just dispatched here to make things work.
            });
        });
        tl.add(new gsap_1.TweenLite(this, duration, {}), 0);
        return tl;
    }
    getReelConfig(reelId) {
        return this._reelConfigs[reelId];
    }
    startNearWin(reelId, duration) {
        duration = duration != undefined ? duration : this._reelConfigs[reelId].nearWinDuration;
        const reel = Reels_1.Reels._reels[reelId];
        const tl = new gsap_1.TimelineLite();
        tl.eventCallback("onStart", () => {
            if (reel.currentState === ReelAnimationState_1.ReelAnimationState.SPIN && !reel.isNearWin) {
                reel.playNearWin(reelId);
            }
        });
        tl.add(new gsap_1.TweenLite(this, duration, {}));
        return tl;
    }
}
exports.TimelineReelsController = TimelineReelsController;
//# sourceMappingURL=TimelineReelsController.js.map